import { setUsersSituation } from 'pages/Login/store/actions';
import { setFilters, setNoEstablishmentFilters } from './actions';
import { fetchFilters, fetchFinancialFilters, fetchUsersSituation } from './services';

export const loadFilters = (userId, establishmentId) => async dispatch => {
  let url = `${userId}/filters`;

  if(establishmentId) {
    url = `${userId}/establishment/${establishmentId}/filters`;
  }

  const response = await fetchFilters(url);
  return dispatch(setFilters(response && response.data));
}

export const loadFinancialFilters = userId => dispatch => {
  return fetchFinancialFilters(userId)
    .then(({ data }) => dispatch(setNoEstablishmentFilters(data)))
    .catch(() => dispatch(setNoEstablishmentFilters([])));
}

export const loadUsersSituation = (userId, token) => dispatch => {
  return fetchUsersSituation(userId, token)
    .then(({ data }) => {
      dispatch(setUsersSituation(data));
      return Promise.resolve(data);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}